import { render } from "./PurchaseAdvisor.vue?vue&type=template&id=a35994b4"
import script from "./PurchaseAdvisor.vue?vue&type=script&lang=js"
export * from "./PurchaseAdvisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__